module.exports = __webpack_public_path__ + "static/media/78.8520f2d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/78.wav
// module id = nGDd
// module chunks = 0